import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import axiosJWT from '../../JwtToken'

export const Edit = ({ rowID, getData, closeEdit, getPesan, setMsg }) => {

    // State Data Master (Snapshot)
    const [dataMaster, setDataMaster] = useState(null)
    const isReadOnly = dataMaster && ['Pengajuan', 'Selesai', 'Dibatalkan', 'Ditolak'].includes(dataMaster.status_realisasi)

    // FORM 1: Update Progress (History Based)
    const [inputKeterangan, setInputKeterangan] = useState("")
    const [inputFileBukti, setInputFileBukti] = useState(null)
    const [statusRealisasi, setStatusRealisasi] = useState("")
    const [statusProgress, setStatusProgress] = useState("")
    const [preview, setPreview] = useState("")
    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    // State Table History
    const [histori, setHistori] = useState([])

    useEffect(() => {
        fetchAllData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchAllData = async () => {
        try {
            const [resMaster, resHistory] = await Promise.all([
                axiosJWT.get(`/api/csr/realisasi/${rowID}`),
                axiosJWT.get(`/api/csr/progress/${rowID}`)
            ])

            const d = resMaster.data
            setDataMaster(d)
            // Preview foto terakhir dari data master kalau belum ada input baru
            if (!preview) setPreview(d.foto_final)
            setHistori(resHistory.data)
        } catch (err) {
            console.log("Fetch Error:", err)
        }
    }

    const openFile = (url) => {
        setFileUrl(url)
        setShowModalFile(true)
    }

    // 1. Keluarin variabel ini biar bisa diakses secara global di dalam file
    const allProgressOptions = [
        { value: 'Pengerjaan', label: 'Pengerjaan Lapangan' },
        { value: 'Pelaporan', label: 'Pelaporan Selesai (100%)' }
    ]

    const getStatusOptions = () => {
        const currentMaster = dataMaster && dataMaster.status_realisasi

        // 2. Sekarang fungsi ini tinggal nge-filter dari array yang di atas tadi
        if (currentMaster === 'Pengajuan') {
            return []
        }
        if (currentMaster === 'Disetujui') {
            return allProgressOptions.filter(opt => ['Pengerjaan'].includes(opt.value))
        }
        if (currentMaster === 'Pengerjaan') {
            return allProgressOptions.filter(opt => ['Pengerjaan', 'Pelaporan'].includes(opt.value))
        }
        if (currentMaster === 'Selesai') {
            return []
        }
        return allProgressOptions
    }

    const mappingStatus = () => {
        return 'Pengerjaan'
    }

    const customStyles = {
        control: (base) => ({
            ...base,
            borderRadius: '0px', // Biar kotak sesuai gaya admin template lama
            borderColor: '#ccc'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#337ab7' : 'white',
            color: state.isSelected ? 'white' : 'black',
            "&:hover": { backgroundColor: "#eee" }
        })
    }

    // LOGIC TOMBOL 1: SIMPAN PROGRESS (INSERT HISTORY & AUTO UPDATE MASTER)
    const handleSimpanProgress = async (e) => {
        e.preventDefault()
        const validationRules = [
            { condition: !statusProgress, msg: "Pilih status progress terlebih dahulu!" },
            { condition: !inputFileBukti, msg: "Wajib upload foto bukti progress lapangan!" }
        ]

        // 2. CEK SATU-SATU (Short-circuit)
        const error = validationRules.find(rule => rule.condition)
        if (error) {
            setMsg(error.msg)
            getPesan()
            setTimeout(() => {
                getPesan()
            }, 2000)
            return
        }

        const formData = new FormData()
        formData.append("status_progress", statusProgress)
        formData.append("status_realisasi", statusRealisasi)
        formData.append("keterangan", inputKeterangan)
        formData.append("file_bukti", inputFileBukti)

        try {
            await axiosJWT.put(`/api/csr/progress/proses/${rowID}`, formData)
            setMsg("Progress Berhasil Dilaporkan!")
            getPesan()

            // Reset field input
            setInputKeterangan("")
            setInputFileBukti(null)
            setPreview("")

            await fetchAllData()
            getData("")

            setTimeout(() => {
                getPesan()
                closeEdit()
            }, 2000)
        } catch (err) {
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : "Gagal update progress"

            setMsg(errorMsg)
            getPesan()

            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const loadFile = (e) => {
        const file = e.target.files[0]
        setInputFileBukti(file)
        setPreview(URL.createObjectURL(file))
    }

    if (!dataMaster) return <div className="p-5">Memuat Data...</div>

    return (<>
        <form onSubmit={handleSimpanProgress} className="form-horizontal">
            <h5 className="right-line color-success">Informasi TJSL/CSR</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="panel panel-info">
                        <div className="panel-heading">Detail TJSL/CSR & Lokasi</div>
                        <div className="panel-body">
                            <div className="row">
                                <table className="table table-condensed" style={{ marginBottom: 0 }}>
                                    <tbody>
                                        <tr>
                                            <th width="40%" className='text-left'>Nama TJSL/CSR</th>
                                            <td className='text-left'>: {dataMaster.nama_program}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Pelaku Usaha (Mitra)</th>
                                            <td className='text-left'>: {dataMaster.nama_pelaku_usaha}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Klaster</th>
                                            <td className='text-left'>: {dataMaster.klaster}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Lokasi</th>
                                            <td className='text-left'>: {dataMaster.kecamatan_csr}, {dataMaster.kelurahan_csr}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Status Realisasi</th>
                                            <td className='text-left'>: <span className={`label ${isReadOnly ? 'label-primary' : 'label-warning'}`}>{dataMaster.status_realisasi}</span></td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Nilai Realisasi</th>
                                            <td className='text-left'>: Rp {dataMaster.nilai_realisasi ? dataMaster.nilai_realisasi.toLocaleString('id-ID') : '0'}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Tanggal Serah Terima</th>
                                            <td className='text-left'>: {dataMaster.tgl_serah_terima ? new Date(dataMaster.tgl_serah_terima).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) : '-'}</td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Dokumen BAST</th>
                                            <td className='text-left'>:
                                                {dataMaster.file_bast ? (
                                                    <a onClick={() => openFile(dataMaster.file_bast)} className="btn btn-xs btn-raised btn-danger">
                                                        <i className="zmdi zmdi-download mr-1"></i> BAST (PDF)
                                                    </a>
                                                ) : <span className="text-muted small"> Tidak tersedia</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="panel panel-default">
                        <div className="panel-heading">Snapshot Progres Terakhir</div>
                        <div className="panel-body text-center">
                            <h2 style={{ marginTop: 0 }}>{dataMaster.progress_persen}%</h2>
                            {dataMaster.foto_final ? (
                                <img src={dataMaster.foto_final} alt="Final" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '5px' }} />
                            ) : <small className="text-muted">Belum ada foto progress</small>}
                        </div>
                    </div>
                </div>
            </div>
            {!isReadOnly && (<>
                <h5 className="right-line color-success">Update Progres Lapangan</h5>
                <div className="row">
                    <div className="form-group col-md-6">
                        <div className="row">

                            <div className="form-group col-md-12">
                                <label>Update Tahapan (Milestone) *</label>
                                <Select
                                    options={getStatusOptions()}
                                    styles={customStyles}
                                    // State yang dipake sekarang harus status_progress
                                    value={allProgressOptions.find(opt => opt.value === statusProgress)}
                                    onChange={(selected) => {
                                        setStatusProgress(selected.value)
                                        // Sekalian set status realisasi (read-only) buat preview di form
                                        setStatusRealisasi(mappingStatus(selected.value))
                                    }}
                                    isDisabled={dataMaster.status_realisasi === 'Selesai'}
                                    placeholder="Pilih Tahapan Progres..."
                                />
                            </div>

                            <div className="form-group col-md-12">
                                <label className="control-label">Foto Bukti Lapangan</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-camera"></i></span>
                                    <input className="form-control" type="file" onChange={loadFile} accept="image/*" />
                                </div>
                                <span className="badge d-inline-block text-wrap badge-danger">Format: .JPG / .PNG (Maks 2MB)</span>
                            </div>

                        </div>
                    </div>

                    <div className="form-group col-md-6 text-center">
                        <label className="control-label">Preview Foto</label>
                        <div style={{ border: '1px solid #ddd', padding: '5px', borderRadius: '4px' }}>
                            {preview ? (
                                <img width="100%" height="160" src={preview} style={{ objectFit: 'cover' }} alt="Preview" />
                            ) : (
                                <img width="100%" height="160" src="/assets/img/no-image.png" alt="No Preview" />
                            )}
                        </div>
                    </div>

                    <div className="form-group col-md-12">
                        <label className="control-label">Keterangan / Kendala Lapangan</label>
                        <div className="input-group">
                            <span className="input-group-addon"><i className="fa fa-comments"></i></span>
                            <textarea className="form-control" rows="3" value={inputKeterangan} onChange={(e) => setInputKeterangan(e.target.value)} placeholder="Contoh: Pemasangan pondasi selesai..."></textarea>
                        </div>
                    </div>
                </div>
            </>)}

            <h5 className="right-line color-success">Aktivitas Progres</h5>
            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-lg-12">
                    <div className="box box-bordered box-color lightgrey">
                        <div className="box-content nopadding">
                            <table className="table table-user table-no-border">
                                <thead>
                                    <tr style={{ background: '#eee' }}>
                                        <th width="180">Waktu Lapor</th>
                                        <th width="100">Progres</th>
                                        <th width="100">Status</th>
                                        <th>Keterangan / Kendala Lapangan</th>
                                        <th width="100" className="text-center">Lampiran</th>
                                        <th width="200">User</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {histori.length > 0 ? histori.map((h, i) => (
                                        <tr key={i}>
                                            <td><small>{new Date(h.i_date).toLocaleString('id-ID')}</small></td>
                                            <td><span className="badge d-inline-block text-wrap badge-success">{h.persentase}%</span></td>
                                            <td>{h.status_progress}</td>
                                            <td className='text-left'>{h.keterangan || '-'}</td>
                                            <td className="text-center">
                                                {h.file_bukti ? (
                                                    <a onClick={() => openFile(h.file_bukti)} className="btn btn-xs btn-raised btn-default">
                                                        <i className="fa fa-image"></i> Lihat
                                                    </a>
                                                ) : '-'}
                                            </td>
                                            <td>{h.nm_user}</td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="4" className="text-center">Belum ada riwayat laporan progress.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                {!isReadOnly && (
                    <button className="btn btn-raised btn-success br-2 no-m" type="submit">
                        <i className="fa fa-send"></i> Kirim Laporan
                    </button>
                )}
                <button type="button" onClick={closeEdit} className="btn btn-raised btn-danger br-2 no-m">
                    <i className="fa fa-sign-out"></i> Batal
                </button>
            </div>
        </form>

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {/* MODAL PREVIEW SERTIFIKAT - Bungkus pake modal-open biar CSS template lu nangkep */}
        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-md">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalFile(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview File TJSL/CSR</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL/CSR"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}
    </>)
}